export default __webpack_public_path__ + "static/media/pdfLogoSite.bfe9dce3.svg";